import { render } from "./TheCartOrderReceivingPickup.vue?vue&type=template&id=ca728f2a"
import script from "./TheCartOrderReceivingPickup.vue?vue&type=script&lang=js"
export * from "./TheCartOrderReceivingPickup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__